import {toggleLoader, handlePromise} from '../../lib';
import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';
import store from '../../store/index';
import { processCheckout as finalCheckout } from '../checkout';

let state = store.state.cartState ? store.state.cartState : {};
let gpay = null;

export default class GpayGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      try {
        const recurlyTokenElement = document.querySelector('#recurly_token');
        if(recurlyTokenElement.value){
          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutInit());
          if (checkoutApiCallErr) return reject(checkoutApiCallErr);
          resolve(checkoutApiCallRes);
        }
      } catch (err) {
        throw reject(err);
      }
    });
  }

  static loadGooglePayIfApplicable() {

    // For bundle cart implmentation
    if (state.proplan_packages !== null) {
      const gpayElement = document.querySelector('#gpay-sec');
      if(gpayElement){
        gpayElement.style.display = 'block';
      }
    }
    else if (state.selected_gateway === 'gpay') {
      document.querySelector('#payment-button').style.display = 'none';
      document.querySelector('#gpay-sec').style.display = 'block';
    }

    // Check if google pay is attached with any of plan
    let GPayPlans = state.plans.filter(function (plan) {
      let filteredGateways = plan.gateways.filter(function (gateway) {
        return gateway.logical_key.toLowerCase() == 'gpay';
      });

      return filteredGateways.length;
    });

    // Initialize google pay when its attached with any of plan
    if (GPayPlans.length) {
      gpay = recurly.GooglePay({
        currency: state.currency_code,
        country: 'US',
        total: window.total_price || '1',
        googleMerchantId: state.google_merchant_id,
        requireBillingAddress: true,
      });
  
      // When the GooglePay instance is ready
      gpay.on('ready', function (gpayButton) {
        console.log('Google Pay ready');
        if (!document.getElementById('gpay-btn-container')) {
            let container = document.createElement('div');
            container.id = 'gpay-btn-container';
            container.style.display = 'block';
            container.appendChild(gpayButton);
            document.querySelector('#gpay-sec').appendChild(container);
        }
      });

      gpay.on('token', async token => {
        console.log('Google Pay token', token);
        document.querySelector('#recurly_token').value = token.id;
        finalCheckout();
      });

      gpay.on('error', err => {
        console.error('Google Pay error', err);
        toggleLoader(false);
      });

      gpay.on('cancel', err => {
        toggleLoader(false);
      });
    }
  }
}
